export function getInnerExceptionErrorCode(error: any, message: boolean = false): string {
	const key = message ? 'Message' : 'Code';

	if (error.InnerException) {
		return getInnerExceptionErrorCode(error.InnerException, message);
	} else if (error[key]) {
		return error[key];
	} else {
		return 'AUTH_SERV_0001';
	}
}
